import type { EmployeeResponse } from 'api/__GENERATED';

// Maps a single Employee DTO from the generated API client onto the
// normalized `Data.Employee` shape. The DTO carries separate first/last name
// fields plus email/mobile/employeeNumbers — only the combined display name
// is needed at the domain level, so fold first + last here.
function toEmployee(dto: EmployeeResponse) {
  const { id, firstName, lastName } = dto;

  const employee: Data.Employee = {
    id,
    name: `${firstName} ${lastName}`.trim(),
  };

  return employee;
}

export { toEmployee };
